import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

import DataContext from '../data/data-context.js';

const useStyles = makeStyles(theme => ({
    root: {
        whiteSpace: 'nowrap'
    },
}));

const SensorName = (props) => {
    const classes = useStyles();
    const { sensorNames } = useContext(DataContext);

    let sensor = sensorNames[props.uuid];
    if (!props.uuid) {
        sensor = Object.values(sensorNames).find(s => s.host === props.host) || {};
    }

    return (
        <span className={classes.root}>
            {sensor ? sensor.name || sensor.host : (props.host || props.uuid)}
        </span>
    );
};

SensorName.propTypes = {
    host: PropTypes.string,
    uuid: PropTypes.string,
};

export default SensorName;
